import React from 'react';
import { errorInput, formSelectService } from '../helpers';
import { Input, Button, Select } from 'semantic-ui-react';
import queryString from 'query-string';
import { RegistrationForm } from 'src/assets/styles/components/Registration';

const GenerateCertificate = (props) => {
  const { setStep, inputs, setInputs, loading, previousEventsNames } = props;
  const [errorInputs, set_errorInputs] = React.useState(0);

  let query = window.location.search;
  let parsedQueryString = queryString.parse(query);

  const verifyForm = () => {
    let mandatoryInputs = ['identification', 'phone'];

    if (props.showName) {
      mandatoryInputs = [...mandatoryInputs, 'name'];
    }

    let errorInputs = {};

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  React.useEffect(() => {
    setInputs({
      ...inputs,
      eventSlugname: parsedQueryString.event,
    });
  }, []);

  const checkCertificate = (e) => {
    e.preventDefault();
    if (verifyForm()) return;
    setStep(1);
  };

  const selectHandle = (a, { value }) => {
    props.history.push(`/certificado/evento?event=${value}`);
    setInputs({ ...inputs, eventSlugname: value });
  };

  const handleInputs = (event) => {
    const { name, value } = event.target;
    setInputs({ ...inputs, [name]: value });
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  return (
    <>
      <RegistrationForm onSubmit={(e) => checkCertificate(e)}>
        <h3>{props.title} </h3>
        <label style={{ display: 'block', padding: '20px', fontSize: '35px' }}>
          Escribe los datos del certificado
        </label>
        {props.showName && (
          <Input
            style={{ width: '33%', margin: '5px' }}
            onChange={handleInputs}
            name={'name'}
            value={inputs.name}
            placeholder="Nombre"
            id="name"
            className={`Registration__input Registration__input-${'name'} ${
              errorInputs['name'] ? 'error' : ''
            }`}
          />
        )}
        {window.location.pathname.includes('certificado/evento') && (
          <div>
            {formSelectService({
              Select,
              label: 'Evento del certificado',
              name: 'eventSlugname',
              handler: selectHandle,
              value: parsedQueryString.event,
              options: previousEventsNames,
            })}
          </div>
        )}
        <Input
          style={{ width: '33%', margin: '5px' }}
          onChange={handleInputs}
          name={'identification'}
          value={inputs.identification}
          type="number"
          placeholder="Identificación"
          id="identification"
          className={`Registration__input Registration__input-${'identification'} ${
            errorInputs['identification'] ? 'error' : ''
          }`}
        />
        <Input
          style={{ width: '33%', margin: '5px' }}
          onChange={handleInputs}
          name={'phone'}
          value={inputs.phone}
          type="number"
          placeholder="Celular"
          id="phone"
          className={`Registration__input Registration__input-${'phone'} ${
            errorInputs['phone'] ? 'error' : ''
          }`}
        />
        <Button primary type="submit" loading={loading}>
          Entrar
        </Button>
      </RegistrationForm>
    </>
  );
};

export default GenerateCertificate;
